import React, { useContext, useEffect, useState } from 'react'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useUploadDataStatus } from '../../hooks/Others/useUploadDataStatus'
import { OtherContext } from '../../context api/Others/OtherContext'
import { useParams } from 'react-router-dom'
import { paginatedData, paginatePages, ROUTES } from '../../shared/constants'
import { useDownload } from '../../hooks/Download/useDownload'

export default function StatusTable({ module, tableHeading, tableData }) {
  const { getAllUploadDataStatus, loading } = useUploadDataStatus()
  const { getPdfCsvData, pdfCsvData } = useDownload()
  console.log('pdfCsvData : ', pdfCsvData)
  const params = useParams()
  const { uploadedData } = useContext(OtherContext)
  const [searchQuery, setSearchQuery] = useState('')
  const filterUploadedData = uploadedData
  const [page, setPage] = React.useState(1)
  let dataLength = filterUploadedData ? filterUploadedData[0].failedData?.length + filterUploadedData[0].successData?.length : 0
  console.log({ dataLength })
  const noOfPages = paginatePages(dataLength)

  useEffect(() => {
    getAllUploadDataStatus({
      searchQuery,
      module: module === 'SFTP' ? 'SALES' : module,
      uploadDataId: params.statusId,
      limit: 40,
    })
  }, [searchQuery, params.statusId])

  useEffect(() => {
    getPdfCsvData('GET_ALL_UPLOAD_DATA', { module, uploadDataId: params.statusId })
  }, [params.statusId])

  const handleChange = (event, value) => setPage(value)
  const headings = uploadedData
    ? filterUploadedData && filterUploadedData[0].failedData.length > 0
      ? filterUploadedData[0].failedData[0]
      : filterUploadedData[0].successData.length && filterUploadedData[0].successData[0]
    : []
  const tempHeadings = Object.keys(headings)
  let tableBody = []
  let failedArray = filterUploadedData ? filterUploadedData[0]?.failedData : []
  let SuccessArray = filterUploadedData ? filterUploadedData[0]?.successData : []
  let finalArray = [...failedArray, ...SuccessArray]

  if (!loading && filterUploadedData.length > 0) {
    let failedData = filterUploadedData && filterUploadedData.map((item) => paginatedData(finalArray, page).map((val) => tableData(val, tempHeadings)))
    tableBody = [...failedData[0]]
  }

  //console.log('TABLE BODY : ', tableBody)

  const layoutProps = {
    heading2: module,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    downloadFailed: filterUploadedData && filterUploadedData[0].failedData.length > 0 && pdfCsvData.failedData,
    downloadSuccess: filterUploadedData && filterUploadedData[0].successData.length > 0 && pdfCsvData.successData,
    heading: `OVERVIEW ${module}`,
    url1: ROUTES[`OVERVIEW_${module}_STATUS`],
  }

  return (
    <CustomTableLayout
      tableHeadings={tableHeading ? tableHeading : [...tempHeadings]}
      loading={loading}
      tableBody={tableData ? tableBody : []}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      border
    />
  )
}
